module.exports = __webpack_public_path__ + "img/testimonial.601b56d0.svg";